import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/totalPass";
import { GetTotalPassList } from "../../reducers/totalPass";

export interface TotalPassListDispatcher {
  getTotalPassList: (filter: any) => Promise<Preview<GetTotalPassList>>;
}

export const totalPassListDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TotalPassListDispatcher = dispatch => ({
  getTotalPassList: (filters: any) => {
    return dispatch(actions.getTotalPassList(filters));
  }
});
